import { ColorPickerForm } from "./ColorPickerForm";
import { Header } from "./Header";
import { PopperWrapper } from "./PopperWrapper";

interface ColorPickerFieldProps {
  colors: string[];
  dataTestId?: string;
  onChange: (input: string) => void;
  pickerColorsTestId?: string;
  subtitle: string;
  value: string;
}

export const ColorPickerField = ({
  dataTestId,
  pickerColorsTestId,
  value,
  subtitle,
  onChange,
  colors,
}: ColorPickerFieldProps) => (
  <PopperWrapper color={value} dataTestId={dataTestId}>
    <Header />
    <ColorPickerForm
      value={value}
      subtitle={subtitle}
      onChange={onChange}
      colors={colors}
      pickerColorsTestId={pickerColorsTestId}
    />
  </PopperWrapper>
);
